import React, { useState } from 'react';
import { capitalize } from 'lodash';
import { Dialog, Box, makeStyles } from '@material-ui/core';

import { Close } from '~/components/icons/Close';

const useStyles = makeStyles(() => ({
  dialog: {
    '& .MuiDialog-paperScrollPaper': {
      display: 'flex',
      width: '360px',
      padding: 'var(--utilities-size-none, 0px)',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 'var(--utilities-size-none, 0px)',
      borderRadius: 'var(--utilities-border-radius-xl, 16px)',
      background: 'var(--background-surface-default, #FFF)',
      boxShadow: 'var(--shadows-modal)',
    },
  },
  titleSection: {
    display: 'flex',
    padding:
      'var(--utilities-size-1-250, 20px) var(--utilities-size-1-500, 24px)',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'var(--utilities-size-1-000, 16px)',
    alignSelf: 'stretch',
    background: 'var(--surface-default, #FFF)',
  },
  mainSection: {
    display: 'flex',
    padding:
      'var(--utilities-size-none, 0px) var(--utilities-size-1-500, 24px) var(--utilities-size-1-500, 24px) var(--utilities-size-1-500, 24px)',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    gap: 'var(--utilities-size-1-500, 24px)',
    alignSelf: 'stretch',
    background: 'var(--surface-default, #FFF)',
  },
  title: {
    flex: '1 0 0',
    color: 'var(--content-primary, #2C313A)',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-md, 16px)',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'var(--typography-line-height-md-line, 24px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
  closeIcon: {
    width: 'var(--utilities-size-1-500)',
    height: 'var(--utilities-size-1-500)',
    cursor: 'pointer',
  },
  textSection: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: 'var(--utilities-size-1-000, 16px)',
    alignSelf: 'stretch',
  },
  buttonsSection: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 'var(--utilities-size-1-000, 16px)',
    alignSelf: 'stretch',
  },
  warningText: {
    alignSelf: 'stretch',
    color: 'var(--content-primary, #2C313A)',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-md, 16px)',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'var(--typography-line-height-md-line, 24px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
  separator: {
    width: '312px',
    height: '1px',
    background: 'var(--border-control-default, rgba(23, 28, 38, 0.20))',
  },
  user: {
    alignSelf: 'stretch',
    color: 'var(--content-primary, #2C313A)',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-md, 16px)',
    fontStyle: 'normal',
    fontWeight: 700,
    lineHeight: 'var(--typography-line-height-md-line, 24px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
  email: {
    color: 'var(--content-primary, #2C313A)',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-md, 16px)',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: 'var(--typography-line-height-md-line, 24px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
  cancelButton: {
    display: 'flex',
    minHeight: 'var(--utilities-size-2-500, 40px)',
    padding:
      'var(--utilities-size-0-500, 8px) var(--utilities-size-1-000, 16px)',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'var(--utilities-size-0-500, 8px)',
    flex: '1 0 0',
    borderRadius: 'var(--utilities-border-radius-default, 8px)',
    border: '1px solid var(--border-control-default, rgba(23, 28, 38, 0.20))',
    background: 'var(--surface-default, #FFF)',
    boxShadow: '0px 1px 2px 0px rgba(23, 28, 38, 0.05)',
    '&:hover': {
      backgroundColor:
        'var(--surface-hover-tint-weak-hover, rgba(23, 28, 38, 0.10))',
      cursor: 'pointer',
    },
  },
  cancelText: {
    color: 'var(--content-primary, #2C313A)',
    textAlign: 'center',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-md, 16px)',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'var(--typography-line-height-md-line, 24px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
  deleteButton: {
    display: 'flex',
    minHeight: 'var(--utilities-size-2-500, 40px)',
    padding:
      'var(--utilities-size-0-500, 8px) var(--utilities-size-1-000, 16px)',
    justifyContent: 'center',
    alignItems: 'center',
    gap: 'var(--utilities-size-0-500, 8px)',
    flex: '1 0 0',
    borderRadius: 'var(--utilities-border-radius-default, 8px)',
    background: 'var(--surface-danger, #EF4444)',
    boxShadow: '0px 1px 2px 0px rgba(23, 28, 38, 0.05)',
    '&:hover': {
      background: 'var(--surface-hover-danger-hover, #dc2626)',
      cursor: 'pointer',
    },
  },
  deleteText: {
    color: 'var(--content-inverted, #FFF)',
    textAlign: 'center',
    fontFamily: 'var(--typography-font-family-default, Inter)',
    fontSize: 'var(--typography-font-size-md, 16px)',
    fontStyle: 'normal',
    fontWeight: 500,
    lineHeight: 'var(--typography-line-height-md-line, 24px)',
    letterSpacing: 'var(--typography-letter-spacing-default, 0px)',
  },
}));

const DeleteUserDialog = ({
  open,
  onClose,
  setDialogOpen,
  userRole,
  userEmail,
  userFirstName,
  userLastName,
  onConfirm,
}) => {
  const classes = useStyles();

  const [hoveredClose, setHoveredClose] = useState(null);

  const handleClose = () => {
    setDialogOpen(false);
  };

  const handleConfirm = () => {
    setDialogOpen(false);
    onConfirm();
  };

  return (
    <Dialog open={open} onClose={onClose} className={classes.dialog}>
      <Box className={classes.titleSection}>
        <Box className={classes.title}>Deleting user</Box>
        <Box
          className={classes.closeIcon}
          onClick={handleClose}
          onMouseEnter={() => setHoveredClose(true)}
          onMouseLeave={() => setHoveredClose(null)}
        >
          <Close color={hoveredClose ? '#2C313A' : '#7c7e83'} />
        </Box>
      </Box>
      <Box className={classes.mainSection}>
        <Box className={classes.textSection}>
          <Box className={classes.warningText}>
            Are you really sure you want to delete this user?
          </Box>
          <Box className={classes.separator}></Box>
          <Box>
            <Box className={classes.user}>
              {!userFirstName && !userLastName
                ? `User (${capitalize(userRole)})`
                : `${userFirstName || ''} ${userLastName || ''} (${capitalize(
                    userRole,
                  )})`}
            </Box>
            <Box className={classes.email}>{userEmail}</Box>
          </Box>
        </Box>
        <Box className={classes.buttonsSection}>
          <Box className={classes.cancelButton} onClick={handleClose}>
            <Box className={classes.cancelText}>Cancel</Box>
          </Box>
          <Box className={classes.deleteButton} onClick={handleConfirm}>
            <Box className={classes.deleteText}>Yes, delete</Box>
          </Box>
        </Box>
      </Box>
    </Dialog>
  );
};

export default DeleteUserDialog;
